export { default } from './AdvancedTab'
